export default __webpack_public_path__ + "static/media/next-arrow.8dc49f21.svg";